"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDirFromProps;

var _useWebChatAPIContext = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useDirFromProps() {
  return [(0, _useWebChatAPIContext.default)().dir];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VEaXJGcm9tUHJvcHMiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsImRpciJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL3VzZURpckZyb21Qcm9wcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZURpckZyb21Qcm9wcygpIHtcbiAgcmV0dXJuIFt1c2VXZWJDaGF0QVBJQ29udGV4dCgpLmRpcl07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLGVBQVQsR0FBMkI7RUFDeEMsT0FBTyxDQUFDLElBQUFDLDZCQUFBLElBQXVCQyxHQUF4QixDQUFQO0FBQ0QifQ==